import { render } from "./EmptyData.vue?vue&type=template&id=3cb9fea3&scoped=true&ts=true"
import script from "./EmptyData.vue?vue&type=script&lang=ts"
export * from "./EmptyData.vue?vue&type=script&lang=ts"

import "./EmptyData.vue?vue&type=style&index=0&id=3cb9fea3&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/saas-fulfillment-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cb9fea3"]])

export default __exports__